// Github : https://github.com/eternicode/bootstrap-datepicker
// Doc : http://bootstrap-datepicker.readthedocs.org/en/stable/index.html


// Bootstrap (webstrap) dependencies
require("webstrap/dropdowns");


// Style
//
// Here what is going on, from "right to left" :
//
// 1. Require an SCSS file (empty or not)
// 2. Prepend the LESS code, converted to SCSS, to the previous SCSS file (using a loader).
// 4. Compile SASS (sass-loader)
//
// For some reason, I can't change the loader order using "-!" at
// the begining of the require to prevent execution of "preLoader"
// and "loaders" (an error occure). But keeping the whole webpack
// configuration doesn't seem to pose any problem.
//
require("sass!./datepicker-loader.js!./datepicker.scss");


// JavaScript
//
var $ = jQuery = require("jquery");
var cookiesUtils = require('cookies-utils');

// Require datepicker JS + Language (minified JS to save space)
require("bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js");
require("bootstrap-datepicker/js/locales/bootstrap-datepicker.fr.js");

// Change default options
$.fn.datepicker.defaults.format = 'yyyy-mm-dd';
$.fn.datepicker.defaults.disableTouchKeyboard = true;
$.fn.datepicker.defaults.orientation = 'bottom';

// Set the language
var localcookie = cookiesUtils.read('localecookie');
if (localcookie == "fr-ca") {
    $.fn.datepicker.defaults.language = 'fr';
}



//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/datepicker/index.js
// module id = 250
// module chunks = 0